import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { getTexts } from '../config/texts';
import { getUserPoints } from '../utils/api';
import './Header.css';

const Header = ({ language, toggleLanguage, currentPage, setCurrentPage }) => {
  const { user, setShowLogin, logout } = useAuth();
  const texts = getTexts('header', language);
  const [points, setPoints] = useState(null);
  const [showMenu, setShowMenu] = useState(false);

  // 加载用户积分
  const loadUserPoints = async () => {
    if (user) {
      try {
        const result = await getUserPoints();
        if (result.code === 200) {
          setPoints(result.data?.available_points || 0);
        }
      } catch (error) {
        console.error('Failed to load user points:', error);
      }
    }
  };

  useEffect(() => {
    loadUserPoints();
  }, [user]);

  const handleLoginClick = () => {
    setShowLogin(true);
  };

  const handleLogout = () => {
    logout();
    setPoints(null);
    setShowMenu(false);
  };

  const handlePageChange = (page) => {
    if (setCurrentPage) {
      setCurrentPage(page);
    }
    setShowMenu(false);
  };

  return (
    <header>
      <div className="logo-wrapper">
        <div className="logo-icon">
          <i className="fas fa-film"></i>
        </div>
        <div className="logo-text">MV<span>ME</span></div>
      </div>

      <div className="header-actions">
        {/* 已登录用户 */}
        {user ? (
          <div className="user-section">
            {/* 积分显示 */}
            <div
              className="points-display"
              title={texts.points || '积分'}
              onClick={() => handlePageChange('recharge')}
            >
              <i className="fas fa-coins"></i>
              <span className="points-value">{points !== null ? points : '...'}</span>
            </div>

            {/* 用户菜单 */}
            <div className="user-menu-container">
              <button
                className="user-profile-btn"
                onClick={() => setShowMenu(!showMenu)}
                title={user.email || user.name}
              >
                <i className="fas fa-user-circle"></i>
                <span>{user.name || user.email?.split('@')[0]}</span>
                <i className={`fas fa-chevron-down ${showMenu ? 'rotate' : ''}`}></i>
              </button>

              {showMenu && (
                <div className="user-dropdown-menu">
                  <button className="menu-item logout" onClick={handleLogout}>
                    <i className="fas fa-sign-out-alt"></i>
                    <span>{texts.logout || '退出登录'}</span>
                  </button>
                </div>
              )}
            </div>
          </div>
        ) : (
          /* 未登录用户 */
          <button
            className="login-btn"
            onClick={handleLoginClick}
          >
            <i className="fas fa-user"></i>
            <span>{texts.login}</span>
          </button>
        )}

        {/* 语言切换 */}
        <button
          className="language-switcher"
          onClick={toggleLanguage}
        >
          <i className={`fas fa-globe ${language === 'en' ? 'fa-americas' : 'fa-asia'}`}></i>
          <span>{language === 'en' ? '中文' : 'EN'}</span>
        </button>
      </div>
    </header>
  );
};

export default Header;